document.addEventListener('DOMContentLoaded', async function() {
    async function fetchHolidaysOnce() {
        const CACHE_KEY = 'holidaysCache';
        const CACHE_EXPIRY_KEY = 'holidaysCacheExpiry';
        const CACHE_DURATION_HOURS = 6; // Refresh every 6 hours

        let holidaysCache = null;
        const cachedData = localStorage.getItem(CACHE_KEY);
        const cacheExpiry = localStorage.getItem(CACHE_EXPIRY_KEY);
        const now = Date.now();

        // Check if cache exists and hasn't expired
        if (cachedData && cacheExpiry && now < parseInt(cacheExpiry, 10)) {
            holidaysCache = JSON.parse(cachedData);
        }

        if (!holidaysCache) {
            try {
                // Add cache-busting parameter to force fresh fetch
                const cacheBuster = `?v=${Date.now()}`;
                const response = await fetch(window.holidaysJsonUrl + cacheBuster);
                if (response.ok) {
                    holidaysCache = await response.json();
                    localStorage.setItem(CACHE_KEY, JSON.stringify(holidaysCache));
                    // Set expiry time
                    const expiryTime = now + (CACHE_DURATION_HOURS * 60 * 60 * 1000);
                    localStorage.setItem(CACHE_EXPIRY_KEY, expiryTime.toString());
                } else {
                    console.error('Failed to fetch holidays.json:', response.status, response.statusText);
                    holidaysCache = { bankHolidays: [], carrierHolidays: [] };
                }
            } catch (error) {
                console.error('Error fetching holidays.json:', error);
                holidaysCache = { bankHolidays: [], carrierHolidays: [] };
            }
        }

        // Make holidays available globally for other widgets
        window.RiiRooHolidays = holidaysCache;
    }

    await fetchHolidaysOnce();
});

document.addEventListener('DOMContentLoaded', function() {
    let debounceTimeout;

    function generateUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    function formatImageUrl(url) {
        if (url.startsWith('//')) {
            return `https:${url}`;
        } else if (!url.startsWith('http')) {
            return `https://riiroo.com${url}`;
        }
        return url;
    }

    function formatPrice(price) {
        return (price / 100).toFixed(2);
    }

    function initializeWishlistDrawer() {
        const event = new Event('openWishlistDrawer');
        document.dispatchEvent(event);
    }

    function updateWishlistButtonState(button, variantId) {
        const wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
        const variantExists = wishlist.some(item => item.variantId == variantId);

        if (variantExists) {
            button.classList.add('wishlisted');
        } else {
            button.classList.remove('wishlisted');
        }
    }

    function handleWishlistButtonClick(event) {
        event.preventDefault();
        const button = event.currentTarget;
        toggleWishlist(button);
    }

    function toggleWishlist(button) {
        const variantId = button.getAttribute('data-variant-id');
        let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
        const wishlistIndex = wishlist.findIndex(item => item.variantId == variantId);

        button.classList.add('pulsing');

        if (wishlistIndex !== -1) {
            // Optimistically remove item from wishlist
            button.classList.remove('wishlisted');
            wishlist.splice(wishlistIndex, 1);
            localStorage.setItem('wishlist', JSON.stringify(wishlist));

            // Send request to remove item from wishlist
            fetch('https://bp9i98qaj3.execute-api.eu-west-2.amazonaws.com/dev/wishlist', {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': 'IKnJCNa3TV4Lo02mQu4QZ5fpf6fhKoOk3PXTb9Mp'
                },
                body: JSON.stringify({ variantId: variantId }),
            })
            .then(response => response.json())
            .then(data => {
                if (!data.success) {
                    // Revert UI change if request fails
                    wishlist.push(wishlistIndex, 0, product);
                    localStorage.setItem('wishlist', JSON.stringify(wishlist));
                    button.classList.add('wishlisted');
                }
            })
            .catch(error => {
                console.error('Error:', error);
                // Revert UI change if request fails
                wishlist.push(wishlistIndex, 0, product);
                localStorage.setItem('wishlist', JSON.stringify(wishlist));
                button.classList.add('wishlisted');
            });
        } else {
            const imageUrl = formatImageUrl(button.getAttribute('data-image-url'));
            // Logging removed

            const product = {
                customerId: ShopifyAnalytics.meta.page.customerId || generateUUID(),
                productId: button.getAttribute('data-product-id'),
                productHandle: button.getAttribute('data-product-handle'),
                variantId: variantId,
                title: button.getAttribute('data-title'),
                price: button.getAttribute('data-price').replace(/[^\d.-]/g, ''),
                imageUrl: imageUrl,
                variantSKU: button.getAttribute('data-variant-sku'),
                variantColor: button.getAttribute('data-variant-color') === 'Default Title' ? '' : button.getAttribute('data-variant-color')
            };

            // Optimistically add item to wishlist
            button.classList.add('wishlisted');
            wishlist.push(product);
            localStorage.setItem('wishlist', JSON.stringify(wishlist));

            // Send request to add item to wishlist
            fetch('https://bp9i98qaj3.execute-api.eu-west-2.amazonaws.com/dev/wishlist', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': 'IKnJCNa3TV4Lo02mQu4QZ5fpf6fhKoOk3PXTb9Mp'
                },
                body: JSON.stringify(product),
            })
            .then(response => response.json())
            .then(data => {
                if (!data.success) {
                    // Revert UI change if request fails
                    wishlist.pop();
                    localStorage.setItem('wishlist', JSON.stringify(wishlist));
                    button.classList.remove('wishlisted');
                }
            })
            .catch(error => {
                console.error('Error:', error);
                // Revert UI change if request fails
                wishlist.pop();
                localStorage.setItem('wishlist', JSON.stringify(wishlist));
                button.classList.remove('wishlisted');
            });
        }

        setTimeout(() => {
            button.classList.remove('pulsing');
        }, 300);
    }

    function reinitializeWishlistButtons() {
        // Logging removed
        initializeWishlistButtons();
    }

    function debounce(func, wait) {
        return function() {
            clearTimeout(debounceTimeout);
            debounceTimeout = setTimeout(func, wait);
        };
    }

    function initializeWishlistButtons() {
        const wishlistButtons = document.querySelectorAll('.wishlist-toggle, .wishlist-button');
        wishlistButtons.forEach(button => {
            button.removeEventListener('click', handleWishlistButtonClick);
            button.addEventListener('click', handleWishlistButtonClick);

            const variantId = button.getAttribute('data-variant-id');
            updateWishlistButtonState(button, variantId);
        });
        // Logging removed
    }

    function updateWishlistButtonsOnVariantChange(variant) {
        const wishlistButton = document.getElementById('add-to-wishlist');
        if (wishlistButton) {
            wishlistButton.setAttribute('data-variant-id', variant.id);
            const imageUrl = variant.featured_image ? variant.featured_image.src : (document.querySelector('.product-single__photo')?.src || '');
            wishlistButton.setAttribute('data-image-url', imageUrl);
            wishlistButton.setAttribute('data-price', formatPrice(variant.price));
            wishlistButton.setAttribute('data-variant-color', variant.option1 === 'Default Title' ? '' : variant.option1);
            wishlistButton.setAttribute('data-variant-sku', variant.sku);
            updateWishlistButtonState(wishlistButton, variant.id);
        }
    }

    document.addEventListener('page:loaded', function() {
        const recommendationsSection = document.querySelector('product-recommendations');
        if (recommendationsSection) {
            const observer = new MutationObserver(debounce(reinitializeWishlistButtons, 300));
            observer.observe(recommendationsSection, { childList: true, subtree: true });
            // Logging removed
        } else {
            // Logging removed
        }
        setTimeout(initializeWishlistButtons, 2000);
    });

    document.addEventListener('product-recommendations:loaded', function() {
        // Logging removed
        reinitializeWishlistButtons();
        hideDeliveryInfoIfInSections();
    });

    document.addEventListener('shopify:section:load', reinitializeWishlistButtons);
    document.addEventListener('shopify:section:unload', reinitializeWishlistButtons);
    document.addEventListener('shopify:section:select', reinitializeWishlistButtons);
    document.addEventListener('shopify:section:deselect', reinitializeWishlistButtons);
    document.addEventListener('shopify:block:select', reinitializeWishlistButtons);
    document.addEventListener('shopify:block:deselect', reinitializeWishlistButtons);
    document.addEventListener('product-recommendations-loaded', reinitializeWishlistButtons);

    document.addEventListener('variant:change', function(evt) {
        const variant = evt.detail.variant;
        updateWishlistButtonsOnVariantChange(variant);
    });

    reinitializeWishlistButtons();

    // Wishlist drawer functions
    const wishlistButton = document.getElementById('wishlistButton');
    const wishlistButtonDock = document.getElementById('wishlistButtonDock');
    const wishlistButtonNav = document.getElementById('wishlistButtonNav');
    const overlay = document.getElementById('wishlistOverlay');
    const closeButton = document.querySelector('.wishlist-close-button');
    const wishlistDrawer = document.getElementById('wishlistDrawer');

    if (wishlistButton) {
        wishlistButton.addEventListener('click', function(event) {
            event.preventDefault();
            openWishlistDrawer();
        });
    }

    if (wishlistButtonDock) {
        wishlistButtonDock.addEventListener('click', function(event) {
            event.preventDefault();
            openWishlistDrawer();
        });
    }
    if (wishlistButtonNav) {
        wishlistButtonNav.addEventListener('click', function(event) {
            event.preventDefault();
            openWishlistDrawer();
        });
    }
    if (overlay) {
        overlay.addEventListener('click', function() {
            closeWishlistDrawer();
        });
    }

    if (closeButton) {
        closeButton.addEventListener('click', function() {
            closeWishlistDrawer();
        });
    }

    function openWishlistDrawer() {
        if (wishlistDrawer) {
            wishlistDrawer.style.display = 'block';
            loadWishlistItems();
        }
    }

    function closeWishlistDrawer() {
        if (wishlistDrawer) {
            wishlistDrawer.style.display = 'none';
        }
    }

    function loadWishlistItems() {
        const wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
        const wishlistItemsContainer = document.getElementById('wishlist-items');
        wishlistItemsContainer.innerHTML = '';

        if (wishlist.length === 0) {
            wishlistItemsContainer.innerHTML = `
                <div class="drawer__scrollable relative flex justify-center items-start grow shrink text-center">
                    <div class="drawer__empty grid gap-5 md:gap-8">
                        <h2 class="drawer__empty-text font-bold leading-none tracking-tight">Your wishlist is currently empty.</h2>
                        <div class="drawer__empty-message text-sm md:text-base leading-tight rte">
                            <p>😵</p>
                        </div>
                    </div>
                </div>
            `;
            return;
        }

        wishlist.forEach((item, index) => {
            const productUrl = `/products/${item.productHandle}?variant=${item.variantId}`;
            const itemElement = document.createElement('div');
            itemElement.classList.add('wishlist-item');
            itemElement.innerHTML = `
                <div class="horizontal-product flex items-center gap-4 md:gap-6 w-full">
                    <a class="horizontal-product__media media media--square relative overflow-hidden flex-auto" href="${productUrl}" tabindex="-1">
                        <img src="${item.imageUrl}" alt="${item.title}" width="1266" height="1266" loading="lazy" is="lazy-image" class="loaded">
                    </a>
                    <div class="horizontal-product__details flex flex-col justify-start gap-1.5">
                        <div class="grid gap-1">
                            <div class="block">
                                <a href="${productUrl}" class="horizontal-product__title reversed-link font-medium text-base leading-tight">${item.title}</a>
                            </div>
                        </div>
                        <div class="grid gap-1">
                            <p class="text-sm">£${item.price}</p>
                            <p class="text-sm">${item.variantColor}</p>
                        </div>
                    </div>
                    <div class="horizontal-product__quantity shrink-0 text-sm sm:block">
                        <div class="grid gap-3">
                            <button onclick="removeFromWishlist(${index})" type="button" class="button button--secondary button--small icon-with-text" is="hover-button">
                                <span class="btn-fill" data-fill></span>
                                <span class="btn-text">
                                    <svg class="icon icon-close icon-sm" viewBox="0 0 20 20" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M5 15L15 5M5 5L15 15"></path>
                                    </svg>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            `;
            wishlistItemsContainer.appendChild(itemElement);
        });
    }

    window.removeFromWishlist = function(itemIndex) {
        let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
        const removedItem = wishlist.splice(itemIndex, 1)[0];
        localStorage.setItem('wishlist', JSON.stringify(wishlist));
        
        const wishlistItemsContainer = document.getElementById('wishlist-items');
        const itemElements = wishlistItemsContainer.getElementsByClassName('wishlist-item');
        const itemElement = itemElements[itemIndex];

        if (itemElement) {
            itemElement.classList.add('removing');
            itemElement.addEventListener('animationend', function() {
                loadWishlistItems();
                
                if (removedItem) {
                    const variantId = removedItem.variantId;

                    const addToWishlistButton = document.getElementById('add-to-wishlist');
                    if (addToWishlistButton && addToWishlistButton.getAttribute('data-variant-id') === variantId) {
                        addToWishlistButton.style.display = 'flex';
                        addToWishlistButton.classList.remove('wishlisted');
                    }

                    const collectionWishlistButtons = document.querySelectorAll(`.wishlist-toggle[data-variant-id="${variantId}"]`);
                    collectionWishlistButtons.forEach(button => {
                        button.style.display = 'flex';
                        button.classList.remove('wishlisted');
                    });
                }

                const wishlistButton = document.getElementById('wishlistButton');
                if (wishlistButton) {
                    wishlistButton.style.display = wishlist.length > 0 ? 'flex' : 'none';
                }
            }, { once: true });
        } else {
            loadWishlistItems();
        }
    };

    document.addEventListener('openWishlistDrawer', function() {
        openWishlistDrawer();
    });

    function hideDeliveryInfoIfInSections() {
        const recentlyViewedSection = document.querySelector('.recently-viewed.block');
        const relatedProductsSection = document.querySelector('.related-products.block');
        const recommendationsSection = document.querySelector('.product-recommendations');

        const deliveryInfoElements = document.querySelectorAll('[id^="delivery-info-card-"]');
        deliveryInfoElements.forEach(element => {
            const shouldDisplay = element.getAttribute('data-should-display') === 'true';
            const isInRecentlyViewed = recentlyViewedSection && recentlyViewedSection.contains(element);
            const isInRelatedProducts = relatedProductsSection && relatedProductsSection.contains(element);
            const isInRecommendations = recommendationsSection && recommendationsSection.contains(element);

            if (!shouldDisplay || isInRecentlyViewed || isInRelatedProducts || isInRecommendations) {
                element.style.display = 'none';
            } else {
                element.style.display = 'block';
            }
        });
        // Logging removed
    }
});
